export default function PhilosophySection() {
  return (
    <section id="philosophy" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-4 flex flex-col justify-start">
            <div className="space-y-6">
              <h2 className="text-6xl font-bold text-[#065F46] leading-tight" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                理念
              </h2>
              <div className="flex items-center gap-4">
                <div className="w-16 h-0.5 bg-[#10B981]"></div>
                <span className="text-sm text-[#666666] tracking-wider">Philosophy</span>
              </div>
            </div>
            <div className="mt-8 w-full rounded-2xl overflow-hidden">
              <img
                src="https://storage.readdy-site.link/project_files/dd63e7f2-2ad5-4550-918c-a85f51c054ca/3c48b169-c740-49bc-af7f-315c0d1bf776_IMG_8652.png?v=1c4eec663537c2a06ab1f96ff5e46063"
                alt="理念"
                className="w-full h-auto object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-8 space-y-8">
            <div className="inline-block">
              <span className="px-4 py-2 bg-[#ECFDF5] text-[#065F46] text-sm font-medium rounded-full">
                20年の現場経験から
              </span>
            </div>

            <div className="space-y-6 text-[#333333] leading-relaxed">
              <p className="text-base" style={{ lineHeight: '2.0' }}>
                理学療法士として20年間、病院、在宅、施設、訪問リハビリなど、多くの現場で患者様と向き合ってきました。
              </p>
              <p className="text-base" style={{ lineHeight: '2.0' }}>
                その中で、手術を受け、薬を飲み続け、リハビリを続けても、痛みが改善しない方を数多く見てきました。
              </p>
            </div>

            <div className="bg-[#10B981] rounded-3xl p-12 relative overflow-hidden">
              <div className="absolute top-8 left-8 w-12 h-12 flex items-center justify-center">
                <i className="ri-double-quotes-l text-4xl text-white/30"></i>
              </div>
              <p className="text-white text-2xl font-medium leading-relaxed relative z-10" style={{ lineHeight: '1.8' }}>
                もっと身体を根本から<br />
                改善する方法はないのか
              </p>
            </div>

            <div className="space-y-6 text-[#333333] leading-relaxed">
              <p className="text-base" style={{ lineHeight: '2.0' }}>
                私はそう考えるようになりました。同じ理学療法士である山内義弘先生と出会い、また武術家の小沢真太郎先生とめぐり逢い、同じ考え、理論に共感し、セミナーを受講し、卒業生として認定インストラクターとなり整体師になる決意をしました。
              </p>
            </div>

            <div className="bg-white border-2 border-[#10B981] rounded-3xl p-10 mt-12">
              <h3 className="text-2xl font-bold text-[#065F46] mb-6 text-center" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                理念の言葉
              </h3>
              <p className="text-lg text-[#333333] leading-relaxed text-center" style={{ lineHeight: '2.2' }}>
                世の中から不要な手術と薬を無くし、<br />
                誰もが真の健康を手に入れてほしい。<br />
                <strong className="text-[#065F46] font-bold">これが私の整体の理念です。</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}